import { render, staticRenderFns } from "./DesignerDescription.vue?vue&type=template&id=18f39e06&scoped=true"
import script from "./DesignerDescription.vue?vue&type=script&lang=ts"
export * from "./DesignerDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f39e06",
  null
  
)

export default component.exports